import styled from "styled-components";

export const FloatingCardContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap:24px;
    width: 100%;
`;

export const FloatingCardHeaderWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex: 1 1 auto;
    align-items: center;

    & > div {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: center;
    }
    
    & > div > div{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }
    
    & > div > button {
        margin: auto;
    }
`
export const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;


export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const NavigationControls = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    
    & > div.left, & > div.right {
        cursor: pointer;
    }
`;

export const CloseButton = styled.div`
    cursor: pointer;
`;

export const FloatingCardContent = styled.div`
    min-height: 48px;
    
    & > div {
        overflow-y: auto;
        overflow-x: hidden;
        overflow-wrap: break-word;
        word-break: break-word;
        white-space: pre-wrap;
        max-height: 250px;
    }
`;


export const Separator = styled.hr`
  border: 0;
  border-top: 1px solid ${(props) => props.theme.colors.highClearGray};;
  width: 100%;
  background: transparent;
`;